import { BaseQuestionIdentifier } from "./BaseQuestionResource";
import { Link } from "./Link";
import { ReflexiveQuestionResource } from "./ReflexiveQuestionResource";

export enum DisclosureStatus {
  ANSWER_LATER = "ANSWER_LATER",
  CANCELLED = "CANCELLED",
  CONFIRMED = "CONFIRMED",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  UNKNOWN = "UNKNOWN",
}

export interface DisclosurePhysicianIdentifier {
  aliasName: string;
  baseQuestionCode: string;
  caseId: string;
  interviewCode: string;
  interviewInstance: string;
  lifeInstance: string;
  physicianUuid: string;
  stageCode: string;
}

export interface EdhConditionDisclosureResource {
  _embedded: Record<string, unknown>;
  _links: Link[];
  actionsPerRiskType: [];
  aliasName: string;
  aliasReferenceCode: string;
  autorun: boolean;
  baseQuestionsDisclosures: BaseQuestionIdentifier[];
  category: { code: string; description: string; listName: string };
  conditionName: string;
  decisionStep: [];
  defaultCondition: boolean;
  disclosurePhysicians: DisclosurePhysicianIdentifier[];
  disclosureType: { code: string; description: string; listName: string };
  hasPhysicians?: boolean;
  interviewCode: string;
  interviewInstance: string | null;
  lifeInstance: string;
  physicianDetailsRequired: boolean;
  questions: ReflexiveQuestionResource[];
  removableFromBqCodes: string[];
  stageCode: string;
  status: DisclosureStatus;
  triggeredCondAliases: [];
  unknown: boolean;
}
